import * as React from 'react';
import { useEffect, useRef, useState , useMemo} from "react";
import {gridData} from '../data/grid-data'
import {gridColumnDefinitions} from '../data/grid-column-defs'

import { AgGridReact } from 'ag-grid-react'; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import "ag-grid-community/styles/ag-theme-balham.css";
import { Box } from '@mui/material';

export default function PortfolioDataGrid(props){  

 // cell renderer for date field
const UnixDateRenderer = ({ value }) => {
  var date = new Date(value)
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0') // Month is zero-based
  const year = date.getFullYear()

  // Concatenate the day, month, and year with dashes to form the desired format
  const formattedDate = `${day}-${month}-${year}`

  return <span>{formattedDate}</span>;
};

const updatedColDefs = props.colDefs.map(colDef => {
  if (colDef.field === 'date') {
    return { ...colDef, cellRenderer: UnixDateRenderer, sort: 'desc' };
  }
  return colDef;
});

//const [rowData, setRowData] = useState(gridData)
  


// Mapping between the columns in data, columnnames to be shown on UI and their stylings.
 //const [colDefs, setColDefs] = useState(gridColumnDefinitions)
//  const colDefs=
//  [
//     { field: 'date',
//      headerName: 'Date',
//       width: 150,
//       cellRenderer: UnixDateRenderer,
//     cellStyle:{"defaultStyle": {'fontSize': '8px', 'textAlign': 'center'} }
//    },
//     {
//       field: 'country',
//       headerName: 'country',
//       width: 100,
//       editable: false,
//       cellStyle:{"defaultStyle": {'fontSize': '8px', 'text-align': 'center'} }
//     },
//     {
//       field: 'exchange',
//       headerName: 'exchange',
//       width: 250,
//       editable: false,
//       cellStyle:{"defaultStyle": {'fontSize': '8px', 'text-align': 'center'} }
//     },
//     {
//       field: 'code',
//       headerName: 'code',
//       type: 'string',
//       width: 100,
//       editable: true,
//       cellStyle:{"defaultStyle": {'fontSize': '8px', 'justify-content': 'center'} }
//     },
// ]





const defaultColDef = useMemo(() => { 
	return {
        // set every column width
        width: 150,
        // make every column editable
        editable: false,
        // make every column use 'text' filter by default
        cellStyle: {'textAlign': 'center','fontSize': '11px',} ,
        filter: 'agTextColumnFilter',
      menuTabs: ['filterMenuTab'],
    };
}, []);

// function handling the rowclick 
const handleCellClicked = (params) => {  
  // calling the callback function using param   
  onCellClick(params);    
};

// Container: Defines the grid's theme & dimensions.An ag-grid should always bedefined within a div.
// add show loader in here


return (
  <Box className="ag-theme-quartz-dark" sx = {{ width: '100%', height: '400px', overflowY: 'auto'}} >
    {props.rowData.length > 0 ? (
    <AgGridReact className="ag-theme-quartz-dark"
    headerHeight={55} // Adjust the header height as needed
    headerCellClass="custom-ag-grid"
    rowData={props.rowData} 
    columnDefs={updatedColDefs}
    defaultColDef={defaultColDef}
    editable={false}
    />
    ): (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          color: 'red', // Change color here
        }}
      >
        <span>Loading...</span>
      </div>
      )
    }
  </Box>
);

}
